import { ACTION_TYPES } from "../../../constants/index";

const initialState = {
  items: [],
};

const menuReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.SET_EXPIRY_ITEMS:
      return {
        ...state,
        items: action.payload,
      };
    case ACTION_TYPES.CLEAR_EXPIRY_ITEMS:
      return {
        ...state,
        items: [],
      };
    default:
      return state;
  }
};

export default menuReducer;
